"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEISMIC_STYLE_CONSTANTS = void 0;
exports.SEISMIC_STYLE_CONSTANTS = {
    FontFamily: '"Source Sans Pro", "Segoe UI", Frutiger, Helvetica, Arial',
};
//# sourceMappingURL=SeismicStyleConstants.js.map